import { ReactionPills } from './ReactionPills'

interface ReactionBarProps {
  entityType: string
  entityId: string
  envId: string
}

/**
 * Reactions on a whole entity (e.g. the task description). Same pills as
 * comments (design 35), but the ☺ stays visible: it's the only entry point.
 */
export function ReactionBar({ entityType, entityId, envId }: ReactionBarProps) {
  return <ReactionPills entityType={entityType} entityId={entityId} envId={envId} addButton="always" />
}
